import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import { CUSTOMER_ACCESS_PURCHASE } from "../../constants";
import { getFeature } from "../../utils/features";
import styles from "./AppExclusive.scss";

const AppExclusive = () => {
  const { getTranslation, product } = useRuntimeConstants();
  const { customerAccess } = getCustomerLoyaltyAccess(product);
  const isAppAdoptionEnabled = getFeature("eap-app-adoption").isEnabled();

  if (!isAppAdoptionEnabled || customerAccess !== CUSTOMER_ACCESS_PURCHASE) {
    return null;
  }

  return (
    <div className={styles.appExclusive}>
      <p className={styles.title}>
        {getTranslation("download_the_app_app_exclusive_title")}
      </p>
      <p className={styles.description}>
        <span>{getTranslation("pdp_banner_only_on_app_message")}</span>
      </p>
    </div>
  );
};

export default AppExclusive;
